import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { ATTRIBUTION_GROUP_REPORT_ID } from './attributionGroupReportId';

const emptyColumns = [FIELDS.ATTRIBUTION_GROUP].map(createFooterMapper(ATTRIBUTION_GROUP_REPORT_ID));

const reportFooterColumnDefinition = [...emptyColumns];

export default reportFooterColumnDefinition;
